import { useEffect, useRef, useState } from "react"
import { Formik } from "formik"
import { Input } from "reactstrap"
import * as Yup from "yup";
import _ from "lodash";
import "./PaymentMethodFormSection.scss"
import { useDispatch, useSelector } from "react-redux";
import { SessionKeys } from "../../../../../utils/AppUtils";
import { getProvinceMasterData } from "../../../../../redux/user/actions";
import Country from "../../../../../data/country.json";
import { Elements } from "@stripe/react-stripe-js";
import CONFIG from "../../../../../utils/config";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import StripePaymentMethodPanel from "../StripePaymentMethodPanel/StripePaymentMethodPanel";
import useLogin from "../../../../../custom-hooks/useLogin";
import FormButtonComponent from "../../../FormControl/FormButton/FormButtonComponent";
import { Spinner } from "react-bootstrap";
import { CheckoutLockIcon } from "../../../../../utils/SvgComps";
import ConfirmModal from "../../../../modal/ConfirmModal";
import PhoneInput from "react-phone-number-input/input";


const stripePromise = loadStripe(CONFIG.KEY.STRIPE_KEY);

const PaymentMethodFormSection = (props) => {

    const {
        paymentIntentInfo, subscriptionId,
        enableFormField, setEnableFormField
    } = props


    const dispatch = useDispatch();

    const { isLoggedIn, userData } = useLogin()

    const formRef = useRef();
    const stripeRef = useRef();

    const provinceMaster = useSelector((state) => state.user.provinceMaster);
    const userDetailRes = useSelector(state => state.user.userBroker)

    const [isCustomer, setIsCustomer] = useState(false)
    const [existingCardData, setExistingCardData] = useState({})
    const [paymentInProcess, setPaymentInProcess] = useState(false)
    const [isConfirmed, setIsConfirmed] = useState(false)
    const [provinceList, setProvinceList] = useState([]);
    const [confirmModal, setConfirmModal] = useState(false)
    const [errorMsg, setErrorMsg] = useState('')
    const [initialValues, setInitialValues] = useState({
        firstName: "",
        lastName: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "ON",
        postalCode: "",
        country: "CA",
        contactEmail: "",
        brokerage_email: "",
        brokerageName: "",
        phoneNumber: "",
        is_agreed: false
    });

    const validationSchema = Yup.object().shape({
        contactEmail: Yup.string().required("Please enter your email"),
        firstName: Yup.string().required("Please enter first name"),
        lastName: Yup.string().optional(),
        addressLine1: Yup.string().required("Please enter your address"),
        addressLine2: Yup.string().optional(),
        brokerageName: Yup.string().optional(),
        brokerageEmail: Yup.string().optional(),
        city: Yup.string().required("Please enter your city"),
        state: Yup.string().required("Please select a state"),
        phoneNumber: Yup.string().required("Please enter your phone number"),
        postalCode: Yup.string()
            // .matches(
            //   /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
            //   "Invalid pincode"
            // )
            .required("Please enter a pincode"),
        country: Yup.string().required("Please select a country"),
    });

    useEffect(() => {
        dispatch(getProvinceMasterData({
            'module': 'getProvinceMaster',
            postData: {}
        }))
    }, [dispatch])

    useEffect(() => {
        if (!_.isEmpty(userDetailRes)) {
            console.log('USER DATA', userDetailRes)
        }
    }, [userDetailRes])

    useEffect(() => {
        if (!_.isEmpty(provinceMaster)) {
            if (provinceMaster.status === 'success') {
                const plist = provinceMaster.payload.payload
                if (!_.isEmpty(plist)) {
                    if (isLoggedIn) {
                        if (!_.isEmpty(userData)) {
                            console.log('USER DATA', userData)
                            let initValues = {
                                firstName: userData.firstname,
                                lastName: userData.lastname,
                                addressLine1: "",
                                addressLine2: "",
                                city: userData.office_city,
                                state: "ON",
                                postalCode: "",
                                country: "CA",
                                is_agreed: false,
                                contactEmail: userData.email,
                                phoneNumber: "",
                                brokerageEmail: "",
                                brokerageName: userData.broker_name,
                            }
                            let isCus = false
                            if (userData.roles.includes('customer')) {
                                isCus = true;
                                setIsCustomer(isCus)
                            }
                            for (let p of plist) {
                                if (p.name === userData.office_province) {
                                    console.log('DATA INSET', {
                                        firstName: userData.firstname,
                                        lastName: userData.lastname,
                                        addressLine1: "",
                                        addressLine2: "",
                                        city: userData.office_city,
                                        state: p.id,
                                        postalCode: "",
                                        country: "CA",
                                        is_agreed: false,
                                        contactEmail: userData.email,
                                        phoneNumber: "",
                                        brokerageEmail: "",
                                        brokerageName: "",
                                    })
                                    initValues.state = p.id
                                }
                            }
                            setInitialValues(initValues)
                        }
                    }
                    setProvinceList(plist)
                }
            }
        }
    }, [provinceMaster, userData])

    useEffect(() => {
        if (isConfirmed && formRef.current) formRef.current.handleSubmit()
    }, [isConfirmed])

    const renderCardElements = () => {
        return (
            <Elements stripe={stripePromise}>
                <StripePaymentMethodPanel
                    ref={stripeRef}
                    paymentIntentInfo={paymentIntentInfo}
                    setPaymentInProcess={setPaymentInProcess}
                    enableFormField={enableFormField}
                    setErrorMsg={setErrorMsg}
                    subscriptionId={subscriptionId}
                />
            </Elements>
        )
    }

    const handleSubmit = async (values, event) => {
        if (!isConfirmed) {
            setConfirmModal(true)
            setErrorMsg('')
        } else if (enableFormField) {
            console.log(values)
            setIsConfirmed(false)
            setConfirmModal(false)
            setPaymentInProcess(true)
            stripeRef.current.handleStripeSubmit(values)
        }
    }

    const confirmPaymentUpdate = () => {

    }


    return (
        <>
            <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validationSchema}
                validateOnChange={false}
                validateOnBlur={false}
                onSubmit={handleSubmit}
                innerRef={formRef}
            >
                {
                    (formik) => {
                        const { handleSubmit, errors } = formik;

                        return (
                            <form onSubmit={handleSubmit} autoComplete="off">
                                <div className="col-lg-12 col-12">
                                    <div className="payment-info-details">
                                        <div className="form-group">
                                            <div className="input-text ">
                                                <label
                                                    htmlFor="contactEmail"
                                                    className="input__label"
                                                >
                                                    Contact Email<span>*</span>
                                                </label>
                                                <Input
                                                    id="contactEmail"
                                                    className="input__field"
                                                    name="contactEmail"
                                                    type="email"
                                                    placeholder="Enter your email"
                                                    required
                                                    autoComplete="off"
                                                    value={formik.values.contactEmail}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    disabled={isLoggedIn}
                                                />
                                                <span className="error-message">
                                                    {formik.errors.contactEmail ? formik.errors.contactEmail : ""}
                                                </span>
                                            </div>
                                        </div>
                                        {/* {
                                            (!isLoggedIn || isCustomer) ?
                                                <div className="form-group">
                                                    <div className="input-text ">
                                                        <label
                                                            htmlFor="brokerageEmail"
                                                            className="input__label"
                                                        >
                                                            Brokerage Email
                                                        </label>
                                                        <Input
                                                            id="brokerageEmail"
                                                            className="input__field"
                                                            name="brokerageEmail"
                                                            type="email"
                                                            placeholder="Enter your brokerage email"
                                                            required
                                                            autoComplete="off"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            disabled={!enableFormField}
                                                        />
                                                        <span className="error-message">
                                                            {formik.errors.brokerageEmail ? formik.errors.brokerageEmail : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                                :
                                                <div className="form-group">
                                                    <div className="input-text ">
                                                        <label
                                                            htmlFor="brokerageName"
                                                            className="input__label"
                                                        >
                                                            Brokerage Name
                                                        </label>
                                                        <Input
                                                            id="brokerageName"
                                                            className="input__field"
                                                            name="brokerageName"
                                                            type="text"
                                                            placeholder="Enter your brokerage name"
                                                            required
                                                            autoComplete="off"
                                                            value={formik.values.brokerageName}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            disabled={!enableFormField || isLoggedIn}
                                                        />
                                                        <span className="error-message">
                                                            {formik.errors.brokerageName ? formik.errors.brokerageName : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                        } */}
                                        <div className="user-billing-info">
                                            <div className="billing-title">Billing details</div>
                                        </div>
                                        <div className="row">
                                            <div className="form-group">
                                                <div className="input-text ">
                                                    <label
                                                        htmlFor="province"
                                                        className="input__label"
                                                    >
                                                        Region<span>*</span>
                                                    </label>
                                                    <select
                                                        type="text"
                                                        id="country"
                                                        name="country"
                                                        disabled
                                                        value={formik.values.country}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        className="form-select input_searchfield"
                                                        placeholder=""
                                                    >
                                                        <option value="">Select Country</option>
                                                        {Country.map((country, index) => {
                                                            return (
                                                                <option key={index} value={country.code}>
                                                                    {country.name}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                    <span className="error-message">
                                                        {formik.errors.country ? formik.errors.country : ""}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <div className="input-text ">
                                                        <label
                                                            htmlFor="firstName"
                                                            className="input__label"
                                                        >
                                                            {/* First Name<span>*</span> */}
                                                            Full Name<span>*</span>
                                                        </label>
                                                        <Input
                                                            id="firstName"
                                                            className="input__field"
                                                            name="firstName"
                                                            type="text"
                                                            placeholder="Enter your first name"
                                                            required
                                                            autoComplete="off"
                                                            value={`${formik.values.firstName}${formik.values.lastName ? ` ${formik.values.lastName}` : ""}`}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            disabled={!enableFormField || isLoggedIn}
                                                        />
                                                        <span className="error-message">
                                                            {formik.errors.firstName ? formik.errors.firstName : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            {false &&
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <div className="input-text ">
                                                        <label
                                                            htmlFor="lastName"
                                                            className="input__label"
                                                        >
                                                            Last Name<span>*</span>
                                                        </label>
                                                        <Input
                                                            id="lastName"
                                                            className="input__field"
                                                            name="lastName"
                                                            type="text"
                                                            placeholder="Enter your last name"
                                                            required
                                                            autoComplete="off"
                                                            value={formik.values.lastName}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            disabled={!enableFormField || isLoggedIn}
                                                        />
                                                        <span className="error-message">
                                                            {formik.errors.lastName ? formik.errors.lastName : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>}
                                        </div>
                                        <div className="row">
                                            <div className="form-group">
                                                <div className="input-text ">
                                                    <label
                                                        htmlFor="addressLine1"
                                                        className="input__label"
                                                    >
                                                        Address<span>*</span>
                                                    </label>
                                                    <Input
                                                        id="addressLine1"
                                                        className="input__field"
                                                        name="addressLine1"
                                                        type="text"
                                                        placeholder="Enter your address"
                                                        required
                                                        autoComplete="off"
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        disabled={!enableFormField}
                                                    />
                                                    <span className="error-message">
                                                        {formik.errors.addressLine1 ? formik.errors.addressLine1 : ""}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <div className="input-text ">
                                                        <label
                                                            htmlFor="city"
                                                            className="input__label"
                                                        >
                                                            City<span>*</span>
                                                        </label>
                                                        <Input
                                                            id="city"
                                                            className="input__field"
                                                            name="city"
                                                            type="text"
                                                            placeholder="Enter your city"
                                                            required
                                                            autoComplete="off"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            disabled={!enableFormField}
                                                        />
                                                        <span className="error-message">
                                                            {formik.errors.city ? formik.errors.city : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <div className="input-text ">
                                                        <label
                                                            htmlFor="state"
                                                            className="input__label"
                                                        >
                                                            State<span>*</span>
                                                        </label>
                                                        <select
                                                            type="text"
                                                            id="state"
                                                            name="state"
                                                            value={formik.values.state}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            className="form-select input_searchfield"
                                                            placeholder=""
                                                            disabled={!enableFormField}
                                                        >
                                                            <option value="">Select Province</option>
                                                            {provinceList.map((province, index) => {
                                                                return (
                                                                    <option key={index} value={province.id}>
                                                                        {province.name}
                                                                    </option>
                                                                );
                                                            })}
                                                        </select>
                                                        <span className="error-message">
                                                            {formik.errors.state ? formik.errors.state : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <div className="input-text ">
                                                        <label
                                                            htmlFor="postalCode"
                                                            className="input__label"
                                                        >
                                                            Postal code<span>*</span>
                                                        </label>
                                                        <Input
                                                            id="postalCode"
                                                            className="input__field"
                                                            name="postalCode"
                                                            type="text"
                                                            placeholder="Enter your postal code"
                                                            required
                                                            autoComplete="off"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            disabled={!enableFormField}
                                                        />
                                                        <span className="error-message">
                                                            {formik.errors.postalCode ? formik.errors.postalCode : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <div className="input-text ">
                                                        <label
                                                            htmlFor="phoneNumber"
                                                            className="input__label"
                                                        >
                                                            Phone Number<span>*</span>
                                                        </label>
                                                        {/* <Input
                                                            id="phoneNumber"
                                                            className="input__field"
                                                            name="phoneNumber"
                                                            type="text"
                                                            placeholder="Enter your phone number"
                                                            required
                                                            autoComplete="off"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            disabled={!enableFormField}
                                                        /> */}
                                                        <PhoneInput
                                                            defaultCountry="CA"
                                                            // value={value}
                                                            // onChange={setValue}
                                                            required
                                                            id="phoneNumber"
                                                            className="input__field"
                                                            name="phoneNumber"
                                                            placeholder="Enter your phone number"
                                                            value={formik.values.phoneNumber}
                                                            onChange={(e) => {
                                                                if (e) {
                                                                    console.log(e)
                                                                    // setValue(e)
                                                                    // formik.handleChange(e)
                                                                    formik.setFieldValue('phoneNumber', e)
                                                                } else {
                                                                    formik.setFieldValue('phoneNumber', "")
                                                                }
                                                            }}
                                                            onBlur={formik.handleBlur}
                                                            disabled={!enableFormField}
                                                        />
                                                        <span className="error-message">
                                                            {formik.errors.phoneNumber ? formik.errors.phoneNumber : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {renderCardElements()}
                                        <div className="row">
                                            <div className="col-12">
                                                <FormButtonComponent
                                                    btnName={
                                                        paymentInProcess ?
                                                            <Spinner
                                                                as="span"
                                                                animation="border"
                                                                size="sm"
                                                                role="status"
                                                                aria-hidden="true"
                                                                variant="primary"
                                                            />
                                                            : "Update"
                                                    }
                                                    leftIcon={<CheckoutLockIcon />}
                                                    btnAction={() => handleSubmit()}
                                                    isPrimary={true}
                                                    disabled={!enableFormField}
                                                    replaceClassName={'btn-form-comp w-100 mt-4'}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="text-red">
                                                    {errorMsg}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        )
                    }
                }
            </Formik>
            <ConfirmModal 
                confirmModal={confirmModal}
                setConfirmModal={setConfirmModal}
                showModalMsg={"By clicking 'yes', you will be updating your current card. Do you want to proceed?"}
                isConfirm={true}
                confirmAction={() => {
                    setIsConfirmed(true)}
                }
            />
        </>
    )
}

export default PaymentMethodFormSection